// components/industry-templates/InsuranceEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Shield, TrendingUp, Users, FileText } from 'lucide-react';

export const InsuranceEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Insurance Products */}
      {industryData?.insurance_products && (
        <Card className="border-0 bg-gradient-to-br from-blue-600/20 to-indigo-600/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Shield className="w-8 h-8" style={{ color: theme.primary }} />
              Insurance Solutions
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {industryData.insurance_products.map((product: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl border border-white/20">
                  <h3 className="text-xl font-bold text-white mb-2">{product.name}</h3>
                  <p className="text-slate-300 text-sm mb-3">{product.description}</p>
                  <div className="flex gap-2">
                    <Badge style={{ backgroundColor: theme.primary }}>{product.category}</Badge>
                    <Badge variant="outline" className="border-white/20 text-white">{product.coverage}</Badge>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Risk Management */}
      {industryData?.risk_management && (
        <Card className="border-2" style={{ borderColor: theme.primary, backgroundColor: 'rgba(59, 130, 246, 0.1)' }}>
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <TrendingUp className="w-6 h-6" style={{ color: theme.primary }} />
              Risk Management Sessions
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.risk_management.map((session: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg border-l-4" style={{ borderColor: theme.primary }}>
                  <h4 className="font-bold text-white mb-1">{session.topic}</h4>
                  <p className="text-sm text-slate-400">{session.speaker}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
